module.exports = __webpack_public_path__ + "linea-basic-elaboration-10.6c2c972e9ffa7ebb520e.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.svg
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.svg
// module chunks = styles